import React, { useEffect, useState } from "react";
import ContestCard from "../../../features/dashboard/contest/components/ContestCard";
import ChartContest from "../components/ChartContest";
import CardRanking from "../components/CardRanking";
import PieChartContest from "../components/PieChartContest";
import dataMock from "../../../features/dashboard/contest/mockup/contest.json";
import CardWinnerAward from "../components/CardWinnerAward";
import CardLuckyDraw from "../components/CardLuckyDraw";
import "./leaderboard.css";
import {
  getContestByID,
  getContestLuckyDraw,
  getContestWinner,
  getContestMe,
} from "../../../api/contest";
import LoadingIux from "../../../components/loading";
import { useHistory, useParams } from "react-router-dom";

const locale = require("react-redux-i18n").I18n;

const LeaderboardContest = ({ setStep }) => {
  const [dataCard, setDataCard] = React.useState();
  const [dataMe, setDataMe] = useState();
  const history = useHistory();
  const { lang } = useParams();

  const fetchContestsByID = async () => {
    try {
      const response = await getContestByID({
        id: localStorage.getItem("contestId"),
      });
      const data = response.data.data || [];
      setDataCard(data);
    } catch (error) {
      console.error("Error fetching contests:", error);
    }
  };

  const contestId = localStorage.getItem("contestId");

  const fetchContestMe = async () => {
    try {
      const data = await getContestMe({ id: contestId });
      setDataMe(data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const [dataWinner, setDataWinner] = React.useState();

  const fetchWinner = async () => {
    try {
      const response = await getContestWinner({
        id: localStorage.getItem("contestId"),
      });
      const data = response.data.data || [];
      setDataWinner(data);
    } catch (error) {
      console.error("Error fetching contests:", error);
    }
  };

  React.useEffect(() => {
    fetchWinner();
  }, []);

  React.useEffect(() => {
    fetchContestMe();
  }, []);

  const [dataLucky, setDataLucky] = React.useState();

  const fetchLuckyDraw = async () => {
    try {
      const response = await getContestLuckyDraw({
        id: localStorage.getItem("contestId"),
        page: 1,
        limit: 9,
      });
      const data = response.data.data || [];
      console.log(data);
      
      setDataLucky(data);
    } catch (error) {
      console.error("Error fetching contests:", error);
    }
  };

  React.useEffect(() => {
    fetchLuckyDraw();
  }, []);

  React.useEffect(() => {
    fetchContestsByID();
  }, []);

  if (!dataCard) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "70vh" }}>
        <LoadingIux />
      </div>
    );
  }

  return (
    <div className="bg-white p-4" style={{ borderRadius: 20 }}>
      <div className="d-flex align-items-center" style={{ gap: "14px" }}>
        <svg
          width="40"
          height="41"
          viewBox="0 0 40 41"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          onClick={() => {
            history.push(`/${lang}/wallet/contest/previous-events`);
          }}
          style={{ cursor: "pointer" }}
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M19.7071 13.7929C20.0976 14.1834 20.0976 14.8166 19.7071 15.2071L15.4142 19.5H27C27.5523 19.5 28 19.9477 28 20.5C28 21.0523 27.5523 21.5 27 21.5H15.4142L19.7071 25.7929C20.0976 26.1834 20.0976 26.8166 19.7071 27.2071C19.3166 27.5976 18.6834 27.5976 18.2929 27.2071L12.2929 21.2071C11.9024 20.8166 11.9024 20.1834 12.2929 19.7929L18.2929 13.7929C18.6834 13.4024 19.3166 13.4024 19.7071 13.7929Z"
            fill="black"
          />
        </svg>
        <p className="text-header-account-wallet text-left w-100">
          Leaderboard
        </p>
      </div>
      <div className="d-flex flex-column" style={{ gap: "24px" }}>
        {dataCard ? (
          <ContestCard data={dataCard} accountNumber={dataCard.account_type_id} size="horizontal" />
        ) : (
          <LoadingIux />
        )}
        <div className="flex-container">
          <div className="flex-item" style={{ flexBasis: "65%" }}>
            <CardWinnerAward data={dataWinner} />
          </div>
          <div className="flex-item" style={{ flexBasis: "35%" }}>
            <CardLuckyDraw data={dataLucky} />
          </div>
        </div>
        <div className="flex-container">
          <div className="flex-item">
            <CardRanking status={dataCard} dataMe={dataMe} dataWinner={dataWinner} />
          </div>
          <div className="flex-item">
            <PieChartContest status={dataCard} />
          </div>
        </div>
        <ChartContest status={dataCard} />
      </div>
    </div>
  );
};

export default LeaderboardContest;
